export const SCOPE = "modules/payment/";

export const SUBMIT_PAYMENT = SCOPE + "SUBMIT_PAYMENT";
export const GET_CARDS = SCOPE + "GET_CARDS";
export const DELETE_CARD = SCOPE + "DELETE_CARD";
export const GET_INVOICE = SCOPE + "GET_INVOICE";
export const CHECKOUT = SCOPE + "CHECKOUT";
export const SHOW_CREATE_FORM = SCOPE + "SHOW_CREATE_FORM";
export const HIDE_CREATE_FORM = SCOPE + "HIDE_CREATE_FORM";
export const CREATE_INSIDER_PAYMENT_INFO =
  SCOPE + "CREATE_INSIDER_PAYMENT_INFO";
export const BILLING_INFO = SCOPE + "BILLING_INFO";
export const BILLING_ACCOUNT_BALANCE = SCOPE + "BILLING_ACCOUNT_BALANCE";



// WEBPACK FOOTER //
// ./src/modules/payment/types.js